import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PublicationProvider from "../context/PublicationProvider";
import { usePublication } from "../hooks/usePublication";
import Libro from "./Libro";
import { HighlightProvider } from "../context";
import { NotificationProvider } from "../context/notification/notificationContext";

const LibroWrapper = () => {
  let {
    idRevista,
    idLibro,
    idCapitulo: chapterNumber,
    idElementHTML,
  } = useParams();
  // console.log(chapterNumber)
  // let { idCapitulo } = useParams();

  const [id, setId] = useState<string | undefined>(idLibro);
  const [idRev, setIdRevista] = useState<string | undefined>(idRevista);
  // const [chapterNumber, setChapterNumber] = useState<number>(idCapitulo?parseInt(idCapitulo):0)
  // let id = idLibro
  // let chapterNumber = idCapitulo?idCapitulo:"0"
  // setChapterNumber(idCapitulo?parseInt(idCapitulo):0)
  // console.log(chapterNumber)

  const { publication, changePublication } = usePublication();

  // useEffect(() => {

  //     const changeSection = (index: number) =>{
  //     console.log("voy a cambiar")
  //     console.log(publication)
  //         if(publication){
  //             console.log(index)
  //             changePublication({...publication, ...{currentSection: index} })
  //         }

  //     }
  //     changeSection(chapterNumber?(chapterNumber):0)

  // }, [publication, chapterNumber])

  useEffect(() => {
    const delayedScroll = setTimeout(() => {
      if (idElementHTML) {
        // Scroll hacia la sección con el ID específico
        const targetElement = document.getElementById(idElementHTML);

        if (targetElement) {
          targetElement.scrollIntoView();
        }
      }
    }, 500);

    return () => clearTimeout(delayedScroll);
  }, [idElementHTML]);

  function removeHashtag(page: string) {
    // Utilizamos una expresión regular para extraer el número antes del #
    const match = page.match(/^(\d+)(?:#|$)/);

    if (match) {
      // El primer grupo capturado en la expresión regular contiene el número
      return parseInt(match[1], 10);
    } else {
      // Si no hay coincidencia, devolvemos NaN (o puedes manejarlo según tu necesidad)
      return NaN;
    }
  }

  return (
    <PublicationProvider>
      <NotificationProvider>
        <HighlightProvider>
          {/* <p>Este es el capitulo {chapterNumber}</p> */}
          {id ? (
            <Libro
              id={id ? id : ""}
              chapterNumber={chapterNumber ? removeHashtag(chapterNumber) : 0}
              typeLibro={"libro"}
            ></Libro>
          ) : (
            <Libro
              id={idRev ? idRev : ""}
              chapterNumber={chapterNumber ? removeHashtag(chapterNumber) : 0}
              typeLibro={"revista"}
            ></Libro>
          )}
        </HighlightProvider>
      </NotificationProvider>
    </PublicationProvider>
  );
};

export default LibroWrapper;
